import { getImageUrl } from "../../../utils/r2Storage";

export const faqIds = [1, 2, 3, 4, 5];

export const buildStepImages = [
    getImageUrl("pages/faq/step1.webp"),
    getImageUrl("pages/faq/step2.webp"),
    getImageUrl("pages/faq/step3.webp"),
    getImageUrl("pages/faq/step4.webp"),
    getImageUrl("pages/faq/step5.webp"),
];
